export default __webpack_public_path__ + "static/media/JHNavBar.f542ac47.svg";